// Build a clean, self-contained HTML document from course code (no platform plumbing).
export const buildStandaloneHtml = (course, code) => {
  const title = course?.title || "Motion Demo";
  const desc = course?.description || "";
  return `<!DOCTYPE html>
<html lang="zh-CN">
<head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<title>${title} · 动效实验室</title>
<!-- ${desc} -->
<!-- Exported from Frontend Motion Academy (动效实验室) -->
<style>
html,body{margin:0;padding:0;height:100%;}
*{box-sizing:border-box;}
${code.css || ""}
</style>
</head>
<body>
${code.html || ""}
<script>
window.addEventListener('load',function(){
try{
${code.js || ""}
}catch(err){console.error(err);}
});
</script>
</body>
</html>`;
};

const slug = (s) =>
  (s || "motion-demo")
    .toString()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w\u4e00-\u9fa5-]/g, "")
    .toLowerCase();

export const downloadStandaloneHtml = (course, code) => {
  const html = buildStandaloneHtml(course, code);
  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${slug(course?.id || course?.title)}.html`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
